<template>
    <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
            <p v-html="privacyText"></p>
            <div class="button" @click="closeModal()">x</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['privacyText'],
        data() {
            return { isOpen: false };
        },
        methods: {
            openModal() {
                this.isOpen = true;
            },
            closeModal() {
                this.isOpen = false;
            }
        },
    };
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        overflow-y: auto;
    }

    .modal-content {
        position: relative;
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        max-width: 800px;
        width: 100%;
        height: fit-content;
    }
    .button{
        position: absolute;
        top: 10px; 
        right: 10px; 
        width: 30px; 
        height: 30px; 
        background-color: var(--mainColor); 
        color: white; 
        font-size: 20px;  
        display: flex;
        justify-content: center; 
        align-items: center; 
        border-radius: 50%; 
        cursor: pointer; 
        border: none; 
    }
</style>